module.exports = __webpack_public_path__ + "static/media/log.b4707935.PNG";